import React, { useState } from "react";
import { Box, Tab, Tabs, useTheme } from "@mui/material";
import SensorManagement from "../../components/SensorManagement";
import SensorListView from "../../components/SensorListView";
import { useMsal } from "Auth/msal-context";
import { useCustomersList } from '../../hooks/useCloudSelectors';

export const SensorIdContext = React.createContext();

function SensorViewContainer() {
  const theme = useTheme();
  const sites = useCustomersList();
  const { isAdmin } = useMsal();

  console.log("SensorViewContainer sites", sites);

  const [overOrUnder, setOverOrUnder] = useState("Over");
  const [keyword, setKeyword] = useState("");
  const [highlightTargetValue, setHighlightTargetValue] = useState("");

  const resetFilterOptions = () => {
    setOverOrUnder("Over");
    setKeyword("");
    setHighlightTargetValue("");
  };

  // get all customers with sensor sites, keep the structure, so site has a list of sensor devices
  const allSensorSites = sites
    .map((site) => {
      const sensorDevices = site.devices.filter((device) => device.solutionType === "lora");
      if (sensorDevices.length > 0) {
        return {
          ...site,
          devices: sensorDevices,
        };
      }
      return null; // Return null for sites without sensor devices
    })
    .filter((site) => site !== null); // Filter out null values

  console.log("allSensorSites", allSensorSites);

  const [tab, setTab] = useState("sensorList");
  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: tab === "sensorManagement" ? "row" : "column",
      }}
    >
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", overflowY: "auto" }}>
        <Tabs
          value={tab}
          onChange={handleChange}
          centered
          sx={{ borderBottom: `1px solid ${theme.palette.primary.main}`, paddingBottom: 1 }}
        >
          <Tab label="Sensor List" value="sensorList" />
          {isAdmin && <Tab label="Sensor Management" value="sensorManagement" />}
        </Tabs>
        {tab === "sensorList" && <SensorListView allSensorSites={allSensorSites} />}
        {tab === "sensorManagement" && isAdmin && <SensorManagement />}
      </Box>
    </Box>
  );
}

export default SensorViewContainer;
